import React from 'react';
import { StudioFoundationsApp } from '@atlassian/studio-foundations';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
import './global.css';

declare global {
	interface Window {
		STUDIO_APP_VERSION: string;
	}
}

window.STUDIO_APP_VERSION = process.env.BITBUCKET_COMMIT || 'unknown';

const App = (): React.JSX.Element => {
	return <StudioFoundationsApp />;
};

export default App;
